"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectOptionCrumbMaps = void 0;
exports.SelectOptionCrumbMaps = [
    { propertyName: 'displayText', crumbPropertyName: 'displayText' },
    { propertyName: 'name', crumbPropertyName: 'value' },
    { propertyName: 'displayOrder', crumbPropertyName: 'sequence' },
];
